/* global __DEVTOOLS__ */
import PropTypes from "prop-types";
import React, {Component} from "react";
import {Provider} from "react-redux";
import ReduxToastr from "react-redux-toastr";
import {contextMenu, ReactWidgetsLocaleProvider} from "@mc/mc-legacy";
import Layout from "./Layout";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import LoginPage from "./LoginPage";
import LoginAdminPage from "./LoginAdminPage";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

/**
 * Root pro aplikaci.
 */

export default class Root extends Component<{ store: any }> {
    static propTypes = {
        store: PropTypes.object.isRequired,
    };

    render() {
        const {store} = this.props;
        return (
            <ReactWidgetsLocaleProvider>
                <Provider store={store} key="provider">
                    <div className="root-container">
                        <BrowserRouter key="router" basename={(window as any).moduleContextPath}>
                            <Switch>
                                <Route path={"/login-admin"} component={LoginAdminPage}/>
                                <Route path={"/login"} component={LoginPage}/>
                                <Route component={Layout}/>
                            </Switch>
                        </BrowserRouter>
                        <ReduxToastr/>
                        <contextMenu.ContextMenuContainer/>
                    </div>
                </Provider>
            </ReactWidgetsLocaleProvider>
        );
    }
}
